module.exports = __webpack_public_path__ + "img/iStock-870849902-25percent.e71a8eec.png";